<template>
    <div>
        <payment-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                             :paginationData="filterSet.page"></payment-filter-link>
        <payment-list-link :listLayout="listLayout" :paginationData="filterSet.page"
                           :paymentData="List" :memberData="memberData"></payment-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                         :listLength="List.length" :type="paymentType"></pagination-link>
    </div>
</template>

<script>
import PaymentFilterLink from "@/components/payment/PaymentFilterLink";
import PaymentListLink from "@/components/payment/PaymentListLink";
import PaginationLink from "@/components/payment/PaginationLink";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import paymentUtil from "@/components/payment/paymentUtil";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";

const {filterConfig} = paymentUtil;

export default {
    name: "PaymentListComponent",
    mixins: [filterMixins, listMixins, alertMixins, paymentUtil],
    components: {PaymentFilterLink, PaymentListLink, PaginationLink},
    provide() {
        return {
            paymentSetPage: this.setPage,
            setFilter: this.setFilter,
            paymentListSetData: this.setData,
        }
    },
    inject: ['changeLoading'],
    props: {
        paymentType: {default: ''},
        memberKey: ''
    },
    data() {
        return {
            listLayout: '',
            filterLayout: '',
            paginationLayout: '',

            getFunc: '',
            listApiParamSet: {},
            pageRow: 10,
            memberData: {},


            /*필터 classname*/

        }
    },
    created() {
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
        this.initConfig();
    },
    mounted() {
        this.getList(true);
        if (!util.isEmpty(this.memberKey)) {
            this.getMember()
        }
        EventBus.$on('refreshKoinData',this.refreshKoinData)
    },
    beforeDestroy() {
        EventBus.$off('refreshKoinData',this.refreshKoinData)
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initConfig() {
            let config = this.returnPaymentConfig(this.paymentType)
            this.listLayout = config.listLayout;
            this.filterLayout = config.filterLayout;
            this.paginationLayout = config.paginationLayout;
            this.getFunc = config.getFunc;
            this.listApiParamSet = config.listApiParamSet;
            if(!util.isEmpty(this.memberKey)){
                this.listApiParamSet.no = this.memberKey
            }

            let listOptions = {
                url: this.$api.$payment[this.getFunc],
                defaultParams: this.listApiParamSet
            }
            this.initList('api', listOptions);
        },
        getMember() {
            let params = {
                mt: "student",
                no: this.memberKey,
                ss: 1
            }
            try {
                this.$api.$member.getMember(params).then(result => result.Data.Result).then(res => {
                    if (res.Info.type !== 1) {
                        this.errorAlert('회원정보를 불러올 수 없습니다.')
                    } else {
                        this.memberData = res.List[0]
                    }
                })
            } catch (e) {

            }
        },
        refreshKoinData(){
            this.getMember()
            this.getList()
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>